module.exports = __webpack_public_path__ + "img/icon_map_xiaofangshuan_yongshuizhong_dianji.b144cb2a.svg";